<template>
  <div>
    <div class="fw-bold"><i class="fa-solid fa-file me-2"/>配車が確定しました。</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cf from '../../../mixins/commonFunctions';

export default {
  name: 'request-canceled',
  mixins: [cf],
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapState(['notice']),
  },
  watch: {},
  methods: {},
};
</script>

<style lang="scss" module="s">
</style>
